import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Resume.css";
import JobList from "./JobList";
import JobModal from "./JobModal";
import { fetchJobs } from "../../utils/cmsAPI";
import { getCompanySlug } from "../../utils/slugUtils";
import { Typography } from "@mui/material";

const Resume = ({ job, project, loading: propLoading }) => {
  const navigate = useNavigate();
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedJobId, setSelectedJobId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const loadJobs = async () => {
      try {
        const jobsData = await fetchJobs();
        // Reverse the order so highest display_order appears first
        setJobs(jobsData.reverse());
      } catch (error) {
        console.error('Failed to fetch jobs:', error);
      } finally {
        setLoading(false);
      }
    };
    loadJobs();
  }, []);

  // Open modal if job/project props are provided (from URL)
  useEffect(() => {
    if (job && !propLoading) {
      // Use the job directly instead of just the ID to avoid refetching
      setSelectedJobId(job.id || job.company);
      setIsModalOpen(true);
    }
  }, [job, propLoading]);

  const handleJobClick = (jobId, jobData) => {
    setSelectedJobId(jobId);
    setIsModalOpen(true);
    const companySlug = getCompanySlug(jobData?.company || jobId);
    window.history.pushState({}, '', `/company/${companySlug}`);
  };

  const handleCloseModal = () => {
    setSelectedJobId(null);
    setIsModalOpen(false);
    // Update URL back to home if we're on a company/project URL
    if (job || window.location.pathname.startsWith('/company/')) {
      window.history.pushState({}, '', '/');
    }
  };

  return (
    <div className="resume-container" id="resume">
      <div className="resume-content">
        <Typography variant="h2">Selected Work</Typography>
        <p className="resume-description">
          I&apos;m an AI enthusiast who has built several GenAI apps alongside a long career in ML.
          I have over a decade of marketplace experience driving product innovation across multiple
          industries: travel, housing, e-commerce, fashion, and QSR.
        </p>

        {loading ? (
          <p>Loading jobs...</p>
        ) : (
          <JobList jobs={jobs} onJobClick={handleJobClick} />
        )}
      </div>

      <JobModal
        jobId={selectedJobId}
        open={isModalOpen}
        onClose={handleCloseModal}
        initialProject={project}
        job={job}
      />
    </div>
  );
};

export default Resume;